var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.loading
      ? _c("div", { staticClass: "profile-container" }, [
          _c(
            "div",
            {
              staticStyle: {
                width: "100%",
                display: "flex",
                "align-items": "center",
                "justify-content": "center",
                "margin-bottom": "2rem",
              },
            },
            [
              _vm.edit
                ? _c(
                    "md-button",
                    {
                      staticClass: "jb-standard fix",
                      on: { click: _vm.editProfile },
                    },
                    [_vm._v("Edit Profile")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("div", { staticClass: "profile-section" }, [
            _c("div", { staticClass: "profile-row" }, [
              _c("div", { staticClass: "left" }, [
                _vm.profile.profile
                  ? _c("img", {
                      staticClass: "img",
                      attrs: { src: _vm.profile.profile },
                    })
                  : _vm._e(),
                !_vm.profile.profile
                  ? _c("img", {
                      staticClass: "img",
                      attrs: { src: _vm.cardUserImage },
                    })
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "right" }, [
                _c("h3", [
                  _vm._v(_vm._s(_vm.profile.name + " " + _vm.profile.surname)),
                ]),
                _c(
                  "p",
                  {
                    staticClass: "text",
                    staticStyle: { "margin-top": "2rem" },
                  },
                  [_vm._v(_vm._s(_vm.profile.bio))]
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "border-container" }, [
            _c("div", { staticClass: "border" }, [
              _c(
                "h4",
                { staticClass: "title" },
                [
                  _c("md-icon", [_vm._v("videocam")]),
                  _vm._v(" Introductory Video"),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "video-player" },
                [
                  _vm.profile.introductoryVideoUrl
                    ? [
                        _c("iframe", {
                          attrs: {
                            src: _vm.embeddedVideoUrl,
                            width: "100%",
                            height: "100%",
                            frameborder: "0",
                            allowfullscreen: "",
                          },
                        }),
                      ]
                    : [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-direction": "column",
                            },
                          },
                          [
                            _c("h3", [_vm._v("No Introductory Video Found")]),
                            _c("br"),
                            _c(
                              "md-button",
                              {
                                staticClass: "jb-standard",
                                staticStyle: {
                                  width: "fit-content",
                                  margin: "auto",
                                },
                                on: { click: _vm.editProfile },
                              },
                              [_vm._v("Add to Profile")]
                            ),
                          ],
                          1
                        ),
                      ],
                ],
                2
              ),
            ]),
          ]),
          !_vm.loading &&
          _vm.profile.qualifications &&
          _vm.profile.qualifications.length > 0
            ? _c("div", { staticClass: "border-container" }, [
                _c(
                  "h4",
                  { staticClass: "title" },
                  [_c("md-icon", [_vm._v("school")]), _vm._v(" Education")],
                  1
                ),
                _c(
                  "div",
                  {},
                  _vm._l(
                    _vm.profile.qualifications,
                    function (qualification, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "qualification-card" },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c("h3", { staticClass: "card-title" }, [
                              _vm._v(_vm._s(qualification.institution)),
                            ]),
                            _c("p", { staticClass: "date" }, [
                              _vm._v(
                                " " +
                                  _vm._s(qualification.startDate) +
                                  " - " +
                                  _vm._s(
                                    qualification.endDate &&
                                      qualification.endDate !== "Invalid date"
                                      ? qualification.endDate
                                      : "Present"
                                  ) +
                                  " "
                              ),
                            ]),
                          ]),
                          _c("p", { staticClass: "text" }, [
                            _vm._v(_vm._s(qualification.degree)),
                          ]),
                          _c("div", { staticClass: "row pill" }, [
                            _c("p", { staticClass: "tag-pill qualification" }, [
                              _vm._v(_vm._s(qualification.year)),
                            ]),
                          ]),
                        ]
                      )
                    }
                  ),
                  0
                ),
              ])
            : _vm._e(),
          !_vm.loading &&
          _vm.profile.experience &&
          _vm.profile.experience.length > 0
            ? _c("div", { staticClass: "border-container" }, [
                _c(
                  "h4",
                  { staticClass: "title" },
                  [_c("md-icon", [_vm._v("work")]), _vm._v(" Experience")],
                  1
                ),
                _c(
                  "div",
                  {},
                  _vm._l(_vm.profile.experience, function (experience, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "qualification-card" },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c("h3", { staticClass: "card-title" }, [
                            _vm._v(_vm._s(experience.jobTitle)),
                          ]),
                          _c("p", { staticClass: "date" }, [
                            _vm._v(
                              " " +
                                _vm._s(experience.startDate) +
                                " - " +
                                _vm._s(
                                  experience.endDate &&
                                    experience.endDate !== "Invalid date"
                                    ? experience.endDate
                                    : "Present"
                                ) +
                                " "
                            ),
                          ]),
                        ]),
                        _c("p", { staticClass: "text" }, [
                          _vm._v(_vm._s(experience.employer)),
                        ]),
                        _c("p", { staticClass: "text" }, [
                          _vm._v(_vm._s(experience.description)),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _c("div", { staticClass: "border-container" }, [
                _c(
                  "h4",
                  { staticClass: "title" },
                  [_c("md-icon", [_vm._v("work")]), _vm._v(" Experience")],
                  1
                ),
                _c("div", {}, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                      },
                    },
                    [
                      _c("h3", { staticClass: "not-found" }, [
                        _vm._v(
                          "You currently have no experience added on your profile"
                        ),
                      ]),
                      _c("br"),
                      _c(
                        "md-button",
                        {
                          staticClass: "jb-standard",
                          staticStyle: { width: "fit-content", margin: "auto" },
                          on: { click: _vm.editProfile },
                        },
                        [_vm._v("Add to Profile")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
          _vm.passedSkills.length > 0
            ? _c("div", { staticClass: "border-container" }, [
                _c(
                  "h4",
                  { staticClass: "title" },
                  [_c("md-icon", [_vm._v("build")]), _vm._v(" Skills")],
                  1
                ),
                _c("div", [
                  _c(
                    "div",
                    { staticClass: "row pill" },
                    _vm._l(_vm.passedSkills, function (skill) {
                      return _c(
                        "p",
                        { key: skill.id, staticClass: "tag-pill" },
                        [_vm._v(" " + _vm._s(skill.id) + " ")]
                      )
                    }),
                    0
                  ),
                ]),
              ])
            : _c("div", { staticClass: "border-container" }, [
                _c(
                  "h4",
                  { staticClass: "title" },
                  [_c("md-icon", [_vm._v("build")]), _vm._v(" Skills")],
                  1
                ),
                _vm._m(0),
              ]),
          _vm.profile &&
          _vm.profile.preferredCompanies &&
          _vm.profile.preferredCompanies.choices &&
          _vm.profile.preferredCompanies.choices.length > 0
            ? _c("div", { staticClass: "border-container" }, [
                _c(
                  "h4",
                  { staticClass: "title" },
                  [
                    _c("md-icon", [_vm._v("business")]),
                    _vm._v(" Preferred Companies"),
                  ],
                  1
                ),
                _c("div", {}, [
                  _c(
                    "ul",
                    _vm._l(
                      _vm.profile.preferredCompanies.choices,
                      function (choice, index) {
                        return _c("li", { key: index }, [
                          _vm._v(_vm._s(choice)),
                        ])
                      }
                    ),
                    0
                  ),
                ]),
              ])
            : _c("div", { staticClass: "border-container" }, [
                _c(
                  "h4",
                  { staticClass: "title" },
                  [
                    _c("md-icon", [_vm._v("business")]),
                    _vm._v(" Preferred Companies"),
                  ],
                  1
                ),
                _c("div", {}, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                      },
                    },
                    [
                      _c("h3", { staticClass: "not-found" }, [
                        _vm._v(
                          "You currently haven't selected your preferred companies"
                        ),
                      ]),
                      _c("br"),
                      _c(
                        "md-button",
                        {
                          staticClass: "jb-standard",
                          staticStyle: { width: "fit-content", margin: "auto" },
                          on: { click: _vm.editProfile },
                        },
                        [_vm._v("Add to Profile")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
          _vm.profile &&
          _vm.profile.preferredCompanies &&
          _vm.profile.preferredCompanies.department &&
          _vm.profile.preferredCompanies.department.length > 0
            ? _c("div", { staticClass: "border-container" }, [
                _c(
                  "h4",
                  { staticClass: "title" },
                  [
                    _c("md-icon", [_vm._v("business")]),
                    _vm._v(" Preferred Departments"),
                  ],
                  1
                ),
                _c("div", {}, [
                  _c(
                    "div",
                    { staticClass: "row pill" },
                    _vm._l(
                      _vm.profile.preferredCompanies.department,
                      function (department, index) {
                        return _c(
                          "p",
                          { key: index, staticClass: "tag-pill" },
                          [_vm._v(_vm._s(department.department))]
                        )
                      }
                    ),
                    0
                  ),
                ]),
              ])
            : _c("div", { staticClass: "border-container" }, [
                _c(
                  "h4",
                  { staticClass: "title" },
                  [
                    _c("md-icon", [_vm._v("business")]),
                    _vm._v(" Preferred Departments"),
                  ],
                  1
                ),
                _c("div", {}, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                      },
                    },
                    [
                      _c("h3", { staticClass: "not-found" }, [
                        _vm._v(
                          "You currently haven't selected your preferred departments"
                        ),
                      ]),
                      _c("br"),
                      _c(
                        "md-button",
                        {
                          staticClass: "jb-standard",
                          staticStyle: { width: "fit-content", margin: "auto" },
                          on: { click: _vm.editProfile },
                        },
                        [_vm._v("Add to Profile")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
          !_vm.loading && _vm.profile && _vm.profile.cv
            ? _c("div", { staticClass: "border-container" }, [
                _c(
                  "h4",
                  { staticClass: "title" },
                  [_c("md-icon", [_vm._v("description")]), _vm._v(" Resumes")],
                  1
                ),
                _c("div", {}, [
                  _c("div", { staticClass: "resume-list" }, [
                    _c("div", { staticClass: "resume-card-single" }, [
                      _c(
                        "div",
                        { staticClass: "resume-header" },
                        [
                          _c("md-icon", [_vm._v("description")]),
                          _c("span", { staticClass: "file-name" }, [
                            _vm._v(_vm._s(_vm.profile.cv.fileName)),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "resume-actions" },
                        [
                          _c(
                            "md-button",
                            {
                              staticClass: "md-success",
                              on: {
                                click: function ($event) {
                                  return _vm.downloadResume(_vm.profile.cv.url)
                                },
                              },
                            },
                            [
                              _vm._v("Download "),
                              _c(
                                "md-icon",
                                { staticStyle: { color: "white !important" } },
                                [_vm._v("download")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
        ])
      : _c("div", { staticClass: "background" }, [
          _vm.loading
            ? _c("div", { staticClass: "text-center lds-circle" }, [_vm._m(1)])
            : _vm._e(),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "flex-direction": "column",
          "align-items": "center",
          padding: "1rem",
        },
      },
      [
        _c("h3", { staticClass: "not-found" }, [
          _vm._v("No passed skills found on your profile"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", { attrs: { src: require("@/assets/img/logo.png") } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }